import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

import { LOGIN_URL, SITE_MAINTENANCE_URL } from '../constants/constants';
import { setMaintenanceStatus } from 'src/ui/features/Maintenance/state/maintenanceActions';

function requireAuth(Component, required = true) {
  class AuthenticatedComponent extends React.Component {
    static propTypes = {
      isInProgress: PropTypes.bool,
      location: PropTypes.shape({
        pathname: PropTypes.string,
      }),
      setMaintenanceStatus: PropTypes.func.isRequired,
    };

    static defaultProps = {
      isInProgress: false,
      location: null,
    };

    componentDidMount() {
      this.props.setMaintenanceStatus();
    }

    componentDidUpdate(prevProps) {
      const previousPathname = prevProps.location && prevProps.location.pathname;
      const currentPathname = this.props.location && this.props.location.pathname;

      if (previousPathname !== currentPathname) {
        this.props.setMaintenanceStatus();
      }
    }

    render() {
      const { isInProgress } = this.props;
      // If there is a maintenance process in progress, It should redirect to the Maintenance page
      if (isInProgress) {
        return <Navigate to={SITE_MAINTENANCE_URL} replace />;
      }
      const isSessionActive = sessionStorage.getItem('isSessionActive') || false;
      return isSessionActive || !required ? <Component {...this.props} /> : <Navigate to={LOGIN_URL} replace />;
    }
  }
  const mapStateToProps = ({ maintenance }) => {
    return {
      isInProgress: maintenance.isInProgress,
    };
  };
  const mapDispatchToProps = {
    setMaintenanceStatus,
  };
  const ConnectedAuthenticatedComponent = connect(
    mapStateToProps,
    mapDispatchToProps,
  )(AuthenticatedComponent);

  return function AuthenticatedComponentWithRouter(props) {
    const location = useLocation();
    return <ConnectedAuthenticatedComponent {...props} location={location} />;
  };
}

export default requireAuth;
